import React, { useRef, useEffect, useState, useReducer } from 'react';

import Main from './Main';
import Loader from './Loader';
import Error from './Error';
import StartScreen from './StartScreen';
import Question from './Question';

import FinishScreen from './FinishScreen';

//import "../index.css";
import { AnimatePresence, motion } from 'framer-motion';
import axios from 'axios';

// We need to define the intialState in order to use useReduce Hook.
const initialState = {
  questions: [],
  // 'loading', 'error', 'ready', 'active', 'finished'
  status: 'loading',
  index: 0,
  answer: null,
  questionPoint: 0,
  highscore: 0,
  secondsRemaining: null,
  answers: [], // Add this to track all answers
};

function reducer(state, action) {
  switch (action.type) {
    case 'dataReceived':
      return {
        ...state,
        questions: action.payload,
        status: 'ready',
      };
    case 'dataFailed':
      return {
        ...state,
        status: 'error',
      };
    case 'start':
      return {
        ...state,
        status: 'active',
        secondsRemaining: null,
      };
    case 'newAnswer':
      const question = state.questions.at(state.index);

      const newAnswer = {
        questionId: question._id, // Assuming your questions have _id field
        selectedOption: action.payload,
      };

      return {
        ...state,
        answer: action.payload,
        answers: [...state.answers, newAnswer], // Add the new answer to the array
        questionPoint:
          action.payload === question.correctAnswer
            ? state.questionPoint + question.questionPoint
            : state.questionPoint,
      };
    case 'nextQuestion':
      return { ...state, index: state.index + 1, answer: null };
    case 'finish':
      return {
        ...state,
        status: 'finished',
        highscore: state.questionPoint > state.highscore ? state.questionPoint : state.highscore,
      };
    case 'restart':
      return { ...initialState, questions: state.questions, status: 'ready' };

    case 'exit':
      return { ...initialState, status: 'exit' };

    case 'tick':
      return state; // Prevent tick from reducing time

    default:
      throw new Error('Action unkonwn');
  }
}

const AppQuiz = ({
  topicquestions,
  triviaQuizSettings,
  brandColor,
  backToMenu,
  brandFont,
  selectedTopicId,
  currentUserId,
}) => {
  const videoRef = useRef(null);
  const [isCorrect, setIsCorrect] = useState(null); // Add isCorrect state

  const handleVideoPlayPage = () => {
    if (videoRef.current) {
      videoRef.current.muted = false;
      videoRef.current.play();
    }
  };

  const handleVideoEnd = () => {
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
    backToMenu();
  };

  const [
    { questions, status, index, answer, questionPoint, highscore, secondsRemaining, answers },
    dispatch,
  ] = useReducer(reducer, initialState);

  const numQuestions = questions.length;
  const maxPossiblePoints = questions.reduce((prev, cur) => prev + cur.questionPoint, 0);

  useEffect(
    function () {
      dispatch({
        type: 'dataReceived',
        payload: topicquestions,
      });

      dispatch({ type: 'start' });
    },
    [topicquestions]
  );

  useEffect(() => {
    if (status === 'finished') {
      const quizResults = {
        userId: currentUserId, // Get this from your auth system
        topicId: selectedTopicId, // Or pass it as a prop
        answers: answers,
      };

      submitQuizRecord(quizResults);

      const timer = setTimeout(
        () => {
          if (
            triviaQuizSettings?.promoPageVideo?.fileUrl &&
            triviaQuizSettings?.promoPageVideo?.enabled
          ) {
            dispatch({ type: 'exit' }); // Dispatch exit or any other action
          } else {
            backToMenu();
          }
        },
        (triviaQuizSettings?.resultToPromo || 10) * 1000
      ); // Fallback to 10 seconds if undefined

      return () => clearTimeout(timer); // Cleanup on unmount or status change
    }
  }, [status, dispatch, triviaQuizSettings]);

  const submitQuizRecord = async quizResults => {
    console.log('quizResults', quizResults);

    await axios.post('/api/quiz-response', quizResults);
  };

  return (
    <Main>
      {status === 'loading' && <Loader />}
      {status === 'error' && <Error />}
      {status === 'ready' && <StartScreen numQuestions={numQuestions} dispatch={dispatch} />}{' '}
      {status === 'active' && (
        <>
          <div
            style={{
              position: 'absolute',
              top: `${triviaQuizSettings?.quizsetting?.heightoffset}%`,
              left: `${triviaQuizSettings?.quizsetting?.leftoffset}%`,
              right: `${triviaQuizSettings?.quizsetting?.rightoffset}%`,
              // ...(enableOffset ? {} : { width: "100%" }),
              // ...(enableOffset ? {} : { height: "100%" }),
              display: 'flex',
              // flexDirection: "column",
              // alignItems: "center",
              // justifyContent: "center",
              zIndex: 2,
            }}
          >
            {isCorrect === true && triviaQuizSettings?.correctResponseGif?.enabled && (
              <img
                src={triviaQuizSettings.correctResponseGif.fileUrl}
                alt="Correct Answer"
                style={{
                  position: 'absolute',
                  top: '0px',
                  zIndex: '10',
                  // height: "1200px",
                  width: '100%',
                }}
              />
            )}

            <Question
              question={questions[index]}
              dispatch={dispatch}
              answer={answer}
              triviaQuizSettings={triviaQuizSettings}
              numQuestions={numQuestions}
              index={index}
              setIsCorrect={setIsCorrect}
              brandFont={brandFont}
              brandColor={brandColor}
            />
          </div>
        </>
      )}
      {status === 'finished' && (
        <>
          <AnimatePresence mode="wait">
            <motion.div
              //className="video-container"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 2 }}
            >
              <img
                src={triviaQuizSettings?.resultBackMedia?.fileUrl}
                alt="Logo"
                style={{
                  position: 'fixed',
                  padding: '15px',
                  top: '46%',
                  left: '12px',
                  // width: "8%",
                  cursor: 'pointer',
                  zIndex: 4,
                  display: triviaQuizSettings?.resultBackMedia?.enabled ? 'block' : 'none',
                }}
                onClick={backToMenu}
              />
            </motion.div>
          </AnimatePresence>

          <FinishScreen
            questionPoint={questionPoint}
            maxPossiblePoints={maxPossiblePoints}
            highscore={highscore}
            dispatch={dispatch}
            brandColor={brandColor}
            triviaQuizSettings={triviaQuizSettings}
            brandFont={brandFont}
          />
        </>

        // </div>
      )}
      {status === 'exit' && (
        <AnimatePresence mode="wait">
          <motion.video
            ref={videoRef}
            className="videoEle show"
            src={triviaQuizSettings?.promoPageVideo?.fileUrl}
            muted
            preload="auto"
            autoPlay
            onPlay={handleVideoPlayPage}
            onEnded={handleVideoEnd}
            loop={false}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              objectFit: 'cover',
              zIndex: 1,
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 2 }}
          />
        </AnimatePresence>
      )}
    </Main>
  );
};
export default AppQuiz;
